module.exports = __webpack_public_path__ + "static/media/Danger.d3d94c4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Toaster/Danger.svg
// module id = 4353
// module chunks = 1